export const resolveSavedFavouriteBaseContentId = (favouriteId, savedHandoutData = {}, contentData = {}) => {
    if (!favouriteId) return null;
    if (contentData[favouriteId]) return favouriteId;
    return savedHandoutData[favouriteId]?.baseContentId || favouriteId;
};

export const getSavedFavouriteBaseContentIds = (favouriteIds = [], savedHandoutData = {}, contentData = {}) => {
    const resolvedIds = [];
    const seen = new Set();

    favouriteIds.forEach((favouriteId) => {
        const baseContentId = resolveSavedFavouriteBaseContentId(favouriteId, savedHandoutData, contentData);
        if (!baseContentId || seen.has(baseContentId)) return;
        seen.add(baseContentId);
        resolvedIds.push(baseContentId);
    });

    return resolvedIds;
};

export const isSavedHandoutFavourite = (baseContentId, favouriteIds = [], savedHandoutData = {}) => {
    if (!baseContentId) return false;
    return favouriteIds.some((favouriteId) => {
        if (favouriteId === baseContentId) return true;
        return savedHandoutData[favouriteId]?.baseContentId === baseContentId;
    });
};

export const removeSavedHandoutFavourite = (baseContentId, favouriteIds = [], savedHandoutData = {}) => {
    if (!baseContentId) return [...favouriteIds];
    return favouriteIds.filter((favouriteId) => {
        if (favouriteId === baseContentId) return false;
        return savedHandoutData[favouriteId]?.baseContentId !== baseContentId;
    });
};

export const toggleSavedHandoutFavourite = (
    baseContentId,
    favouriteIds = [],
    savedHandoutData = {},
    maxFavourites = 30,
) => {
    if (!baseContentId) {
        return {
            updatedFavourites: [...favouriteIds],
            isFavourite: false,
            limitReached: false,
        };
    }

    const isFavourite = isSavedHandoutFavourite(baseContentId, favouriteIds, savedHandoutData);
    if (isFavourite) {
        return {
            updatedFavourites: removeSavedHandoutFavourite(baseContentId, favouriteIds, savedHandoutData),
            isFavourite: false,
            limitReached: false,
        };
    }

    const canonicalIds = getSavedFavouriteBaseContentIds(favouriteIds, savedHandoutData);
    if (canonicalIds.length >= maxFavourites) {
        return {
            updatedFavourites: [...favouriteIds],
            isFavourite: false,
            limitReached: true,
        };
    }

    return {
        updatedFavourites: [...favouriteIds, baseContentId],
        isFavourite: true,
        limitReached: false,
    };
};
